import { useNavigate } from 'react-router-dom';
import { parseOnboardingPath } from '../../locales/languageConfig';

export const useCustomNavigate = () => {
  const navigate = useNavigate();

  return (path: string) => {
    const { prefix } = parseOnboardingPath(window.location.pathname);
    const nextPath = path || '/';
    const pathname = nextPath.startsWith('/') ? nextPath : `/${nextPath}`;

    navigate(
      {
        pathname: `${prefix}${pathname}`,
        search: window.location.search,
      },
      { replace: true },
    );
  };
};
